import { createSelector } from "reselect";
import { currentUserSelector } from "../current_user_selector";

export const currentUserDataSelector = createSelector(
  currentUserSelector,
  currentUser => {
    return currentUser.data;
  }
);
